let ip = "https://fantasy-league-backend.onrender.com";
// let ip = "http://10.10.113.28:5000"

export default ip;